import {Month} from './import_csv';

export function toYears(months: Month[], referenceDate: Date) {
    const years = [2, 1, 0].map((yearOffset) => {
        const year = referenceDate.getFullYear() - yearOffset;

        const monthsInYear = months.filter((month) => month.date.getFullYear() === year);
        return {
            year: year,
            months: monthsInYear,
            revenue: monthsInYear.reduce((p, c) => p + c.revenue, 0),
            cost: monthsInYear.reduce((p, c) => p + c.cost, 0),
            result: monthsInYear.reduce((p, c) => p + c.result, 0),
        };
    });

    return years;
}
